<ling-input type="text" [formControl]="rule"></ling-input>
<button
  mat-flat-button
  color="primary"
  (click)="createRule()"
  style="margin: 0 auto"
>
  {{ submitButtonText }}
</button>
